import React from "react";
import { BookOpen, ShieldCheck, Megaphone, Wrench, Bell } from "lucide-react";

// What a reader can expect to eventually see here — shown instead of a bare
// "no results" message so an empty Knowledge Base still communicates its
// value, rather than reading as broken or abandoned.
const CONTENT_TYPES = [
  {
    icon: ShieldCheck,
    tone: "info",
    title: "Compliance & Code Updates",
    description: "Inspection requirements and regulatory changes for your trade, as they happen.",
  },
  {
    icon: Wrench,
    tone: "success",
    title: "Trade-Specific Guides",
    description: "Reference material and best practices tailored to your assigned trades.",
  },
  {
    icon: Bell,
    tone: "warning",
    title: "Safety Bulletins",
    description: "Timely alerts on safety procedures and site advisories that affect your work.",
  },
  {
    icon: Megaphone,
    tone: "primary",
    title: "Platform Announcements",
    description: "Product updates and workflow changes from the Surya Group team.",
  },
];

const TONE_CLASSES = {
  info: "bg-info_bg text-info",
  success: "bg-success_bg text-success",
  warning: "bg-warning_bg text-warning",
  primary: "bg-primary_tint text-primary",
};

const EmptyKnowledgeBase = () => (
  <div className="max-w-3xl mx-auto text-center py-12 sm:py-16 px-4">
    <div className="w-16 h-16 mx-auto rounded-lg bg-primary_tint flex items-center justify-center mb-5">
      <BookOpen size={28} className="text-primary" />
    </div>

    <h2 className="text-lg font-bold text-text_primary">Your Knowledge Base is just getting started</h2>
    <p className="text-[13.5px] text-text_muted mt-2 max-w-md mx-auto leading-relaxed">
      Nothing has been published for your trades yet — check back soon. Here's the kind of thing that'll
      show up here once it does:
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 mt-8 text-left">
      {CONTENT_TYPES.map(({ icon: Icon, tone, title, description }) => (
        <div key={title} className="flex items-start gap-3 p-4 rounded-lg border border-border bg-surface shadow-sm">
          <div className={`flex-shrink-0 w-10 h-10 rounded-md flex items-center justify-center ${TONE_CLASSES[tone]}`}>
            <Icon size={18} />
          </div>
          <div className="min-w-0">
            <p className="text-[13px] font-semibold text-text_primary">{title}</p>
            <p className="text-[12px] text-text_muted mt-0.5 leading-relaxed">{description}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default EmptyKnowledgeBase;
